import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_HEAT_TO_ELECTRICAL_ENERGY',
  GET: 'GET_HEAT_TO_ELECTRICAL_ENERGY',
  CREATE: 'CREATE_HEAT_TO_ELECTRICAL_ENERGY',
  EDIT: 'EDIT_HEAT_TO_ELECTRICAL_ENERGY',
  DELETE: 'DELETE_HEAT_TO_ELECTRICAL_ENERGY',
  DUPLICATE: 'DUPLICATE_HEAT_TO_ELECTRICAL_ENERGY',
  CLEAR_ERROR: 'CLEAR_ERROR_HEAT_TO_ELECTRICAL_ENERGY',
};

export const clearErrorHeatToElectricalEnergy = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchHeatToElectricalEnergyByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchHeatToElectricalEnergy(pageSize, page, sorted, filtered, isPublic);
};

const searchHeatToElectricalEnergy = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_HEAT_TO_ELECTRICAL_ENERGY,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listHeatToElectricalEnergy = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchHeatToElectricalEnergy(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createHeatToElectricalEnergy = (name, entropy, volume, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('hs', entropy);
  formData.set('s', volume);
  formData.set('description', description);
  if (image) formData.set('image', image, `photovoltaic_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_HEAT_TO_ELECTRICAL_ENERGY,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editHeatToElectricalEnergy = (id, name, entropy, volume, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (entropy) formData.set('hs', entropy);
  if (volume) formData.set('s', volume);
  if (typeof(description) === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `equipment_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_HEAT_TO_ELECTRICAL_ENERGY}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteHeatToElectricalEnergy = HeatToElectricalEnergyId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_HEAT_TO_ELECTRICAL_ENERGY}${HeatToElectricalEnergyId}/`,
    })
      .then(() => ({ id: HeatToElectricalEnergyId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateHeatToElectricalEnergy = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_HEAT_TO_ELECTRICAL_ENERGY}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/renewable_energy/heat_to_electrical_energy_actions.js